// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Modal, DatePicker, TimePicker, Typography } from 'antd'
import moment from 'moment'

class ModifyJobModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = this._initState(props.job)
  }

  _initState (job) {
    if (job === null) {
      return {
        date: [],
        time: []
      }
    }
    return {
      date: [moment(job.startDate), moment(job.endDate)],
      time: [moment(job.startTime, 'HH:mm:ss'), moment(job.endTime, 'HH:mm:ss')]
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.job !== this.props.job) {
      this.setState({
        ...this._initState(nextProps.job)
      })
    }
  }

  handleDateChange = value => {
    this.setState({
      date: value
    })
  }

  handleTimeChange = time => {
    this.setState({
      time
    })
  }

  handleSubmit = () => {
    const { date, time } = this.state
    this.props.onOk({
      ...this.props.job,
      startDate: date[0].format('YYYY-MM-DD'),
      endDate: date[1].format('YYYY-MM-DD'),
      startTime: time[0].format('HH:mm:ss'),
      endTime: time[1].format('HH:mm:ss')
    })
  }

  handleCancel = () => {
    this.props.onCancel()
    this.setState({
      ...this._initState(this.props.job)
    })
  }

  _renderDateStr () {
    const { date, time } = this.state
    let dateStr
    let timeStr
    if (date.length === 0) {
      dateStr = ''
    } else if (date[0].isSame(date[1])) {
      dateStr = date[0].format('D/M/YYYY')
    } else {
      dateStr = `${date[0].format('D/M/YYYY')}-${date[1].format('D/M/YYYY')}`
    }
    if (time.length === 0) {
      timeStr = ''
    } else if (time[0] === time[1]) {
      timeStr = moment(time[0]).format('hh:mm A')
    } else {
      timeStr = `${moment(time[0]).format('hh:mm A')}-${moment(time[1]).format('hh:mm A')}`
    }
    return (
      <Typography.Text type='primary'>
        {timeStr}
        &nbsp;,&nbsp;
        {dateStr}
      </Typography.Text>
    )
  }

  render () {
    const { date, time } = this.state
    const { job, visible, modifyLoading } = this.props
    if (!job) {
      return null
    }
    return (
      <Modal
        onOk={this.handleSubmit}
        onCancel={this.handleCancel}
        visible={visible}
        width={400}
        okText='confirm'
        confirmLoading={modifyLoading}
        title={job.jobName}
      >
        <div>
          <Typography.Text type='secondary'>Change Date</Typography.Text>
        </div>
        <div>
          <DatePicker.RangePicker style={{ width: 260 }} value={date} onChange={this.handleDateChange} />
        </div>
        <div>
          <Typography.Text type='secondary'>Change Time</Typography.Text>
        </div>
        <div>
          <TimePicker.RangePicker
            style={{ width: 260 }}
            value={time}
            use12Hours
            format='hh:mm A'
            minuteStep={5}
            onChange={this.handleTimeChange}
          />
        </div>
        {this._renderDateStr()}
      </Modal>
    )
  }
}

export default ModifyJobModal
